(function() { window.GUID_0512b6ca_8869_4f21_9bf2_bdb64ce38271 = { getGuid: function() { return "0512b6ca-8869-4f21-9bf2-bdb64ce38271"; } }; })();
var CompuSport;
(function (CompuSport) {
    var Helper;
    (function (Helper) {
        class RenderAjaxAction {
            constructor(uniqueId, url, data) {
                this.Url = url;
                this.Data = data;
                this.TryGet(uniqueId, url, data);
            }
            TryGet(uniqueId, url, data) {
                let me = this;
                if (typeof (CompuSport.trigger) != "undefined") {
                    if (CompuSport.AllScriptsLoaded) {
                        me.CallGet(uniqueId, url, data);
                    }
                    else {
                        CompuSport.on('allscriptsloaded', function () {
                            me.CallGet(uniqueId, url, data);
                        });
                    }
                }
                else {
                    me.retry = window.setTimeout(function () {
                        me.TryGet(uniqueId, url, data);
                    }, 100);
                }
            }
            CallGet(uniqueId, url, data) {
                let me = this;
                CompuSport.Ajax.Get(url, data, function (result) {
                    let content = $('#' + uniqueId);
                    me.Container = $('<div class="RenderAjaxActionContainer">' + result + '</div>');
                    content.replaceWith(me.Container);
                    CompuSport.trigger('ajaxActionRendered', me);
                });
            }
            Refresh() {
                let me = this;
                CompuSport.Ajax.Get(this.Url, this.Data, function (result) {
                    me.Container.html(result);
                    CompuSport.trigger('ajaxActionRefreshed', me);
                });
            }
        }
        Helper.RenderAjaxAction = RenderAjaxAction;
    })(Helper = CompuSport.Helper || (CompuSport.Helper = {}));
})(CompuSport || (CompuSport = {}));

//# sourceMappingURL=RenderAjaxAction.js.map
